import React from "react";
import "./Pagination.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleLeft, faCircleRight} from "@fortawesome/free-regular-svg-icons";

function Pagination({currentPage, totalPages, onPageChange}) {
    const pages = Array.from({length: totalPages}, (_, i) => i + 1);

    return (
        <ul className="pagination">
            {currentPage > 1 && (
                <li className="page-item" onClick={() => onPageChange(currentPage - 1)}>
                        <span className="page-link">
                            <FontAwesomeIcon icon={faCircleLeft}/>
                        </span>
                </li>
            )}

            {pages.map((page) => (
                <li
                    key={page}
                    className={`page-item ${currentPage === page ? "active" : ""}`}
                    onClick={() => onPageChange(page)}
                >
                    <span className="page-link">{page}</span>
                </li>
            ))}

            {currentPage < totalPages && (
                <li className="page-item" onClick={() => onPageChange(currentPage + 1)}>
                        <span className="page-link">
                            <FontAwesomeIcon icon={faCircleRight}/>
                        </span>
                </li>
            )}

        </ul>
    );
}

export {
    Pagination
};
